import { Configuration, RedirectRequest } from '@azure/msal-browser';
import { Environments } from '../@types/configuration';
import environment from './env';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${environment.AZURE_AD_TENANT_ID}`,
    redirectUri: window.location.origin + '/login/callback',
    postLogoutRedirectUri: window.location.origin + '/logout/callback',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0:
            console.error(message);
            return;
          case 1:
            console.warn(message);
            return;
          case 2:
            if ([Environments.DEV].includes(environment.ENV)) {
              console.info(message);
            }
            return;
          case 3:
            if ([Environments.DEV].includes(environment.ENV)) {
              console.debug(message);
            }
            return;
        }
      },
    },
  },
};

export const loginRequest: RedirectRequest = {
  scopes: environment.AZURE_AD_SCOPES,
};
